import { faqData } from '@/utils/constants/faq'
import type { FAQDTO } from '@/types/models'

export type FaqCategoryGroup = {
  title: string
  items: FAQDTO[]
}

const UNCATEGORIZED_TITLE = 'سایر پرسش‌ها'

export function groupFaqsByCategory(faqs: FAQDTO[]): FaqCategoryGroup[] {
  if (!faqs.length) return []

  const faqById = new Map(faqs.map((faq) => [faq.id, faq]))
  const usedIds = new Set<number>()

  const groups = faqData
    .map((section) => {
      const items = section.items
        .map((item) => faqById.get(item.id))
        .filter((item): item is FAQDTO => Boolean(item))

      items.forEach((item) => usedIds.add(item.id))

      return { title: section.title, items }
    })
    .filter((group) => group.items.length > 0)

  const uncategorized = faqs.filter((faq) => !usedIds.has(faq.id))

  if (uncategorized.length > 0) {
    groups.push({ title: UNCATEGORIZED_TITLE, items: uncategorized })
  }

  if (groups.length === 0) {
    return [{ title: 'همه پرسش‌ها', items: faqs }]
  }

  return groups
}
